import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LeadEdit from "@/views/LeadEdit.vue";
import Leads from "@/views/Leads.vue";
import Campaigns from "@/views/Campaigns.vue";
import CampaignEdit from "@/views/CampaignEdit.vue";
import NotFound from "@/views/NotFound.vue";
import Phones from "@/views/Phones.vue";
import TestPage from "@/views/TestPage.vue";

Vue.use(VueRouter);

export const campaignCreateRoute = "/Channels/Create";
export const campaignEditRoute = "/Channels/Edit";
export const campaignsRoute = "/Channels/Index";
export const clientLeadsRoute = "/ContactForms/ClientLeads";
export const leadClientsRoute = "/ContactForms/ClientLeads?pageKind=1";
export const leadsRoute = "/ContactForms/Index";

const routes: Array<RouteConfig> = [
  {
    path: clientLeadsRoute,
    component: Leads,
  },
  {
    path: leadClientsRoute,
    component: Leads,
  },
  {
    path: "/ContactForms/Edit",
    component: LeadEdit,
  },
  {
    path: leadsRoute,
    component: Leads,
  },
  {
    path: campaignsRoute,
    component: Campaigns,
  },
  {
    path: campaignCreateRoute,
    component: CampaignEdit,
  },
  {
    path: campaignEditRoute,
    component: CampaignEdit,
  },
  {
    path: "/Phones/Index",
    component: Phones,
  },
  {
    path: "/testpage",
    component: TestPage,
  },
  {
    path: "*",
    component: NotFound,
    name: "NotFound"
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  linkActiveClass: "is-active",
  routes,
});

export default router;
